document.addEventListener("DOMContentLoaded", function(){
  var target = document.querySelector("#main-cart-footer"); //Athensにあるidに変更
  function deliveryDateLayout() {
    var insertParent = document.querySelector(".cart-footer"); //Athensにあるclassに変更
    var insertPosition = document.querySelector(".cart-blocks"); //Athensにあるclassに変更
    var deliveryDateWrapper = document.querySelector("#deliveryDate__wrapper");
    insertParent.insertBefore(deliveryDateWrapper, insertPosition);
  };
  var observer = new MutationObserver(function(records) {
    records.forEach(function(record) {
      console.log(record);
      if(record.addedNodes.length > 0 && record.addedNodes[0].classList && record.addedNodes[0].classList.contains("Cart")){
        deliveryDateLayout();
        observer.disconnect();
      }
    });
  });
  var config = { childList: true, characterData: true, subtree: true };
  observer.observe(target, config);  
});